// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customer portal dialog in the customer list (rootClassName="customer-portal-admin"). */

.customer-portal-admin .customer-portal-gap {
  margin-bottom: var(--ds-space-4);
}

.customer-portal-admin .customer-portal-decision {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1);
  min-width: 0;
  overflow-wrap: anywhere;
}

.customer-portal-admin .customer-portal-signature {
  max-width: 100%;
  max-height: 90px;
  padding: var(--ds-space-1);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-sm);
  background: var(--ds-surface);
  align-self: flex-start;
}

.customer-portal-admin .customer-portal-hash {
  font-size: 12px;
}

.customer-portal-admin .customer-portal-share {
  display: flex;
  width: 100%;
}

.customer-portal-admin .customer-portal-share .ant-select {
  flex: 1;
  min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/customerPortal/customerPortal.css"],"names":[],"mappings":"AAAA,yFAAyF;;AAEzF;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uCAAuC;EACvC,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd","sourcesContent":["/* Customer portal dialog in the customer list (rootClassName=\"customer-portal-admin\"). */\n\n.customer-portal-admin .customer-portal-gap {\n  margin-bottom: var(--ds-space-4);\n}\n\n.customer-portal-admin .customer-portal-decision {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1);\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.customer-portal-admin .customer-portal-signature {\n  max-width: 100%;\n  max-height: 90px;\n  padding: var(--ds-space-1);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-sm);\n  background: var(--ds-surface);\n  align-self: flex-start;\n}\n\n.customer-portal-admin .customer-portal-hash {\n  font-size: 12px;\n}\n\n.customer-portal-admin .customer-portal-share {\n  display: flex;\n  width: 100%;\n}\n\n.customer-portal-admin .customer-portal-share .ant-select {\n  flex: 1;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
